// extracted by mini-css-extract-plugin
export default {"input":"TextArea_input__UbgpY","textarea":"TextArea_textarea__nBY3a","invalid":"TextArea_invalid__V-v6k","highlighted":"TextArea_highlighted__TeCFj"};